<!--
 * @Description: 开票记录-价税合计
 * @Date: 2024-04-16 11:02:04
-->
<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      :stripe="true"
      :highlight-current-row="false"
      ref="openList"
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        label="订单编号"
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="toFour(row)">
            {{ row.orderNo }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderType"
        label="订单类型"
      >
        <template slot-scope="{ row }">
          {{ row.orderType | orderType }}
        </template>
      </el-table-column>

      <el-table-column
        v-if="options.invoiceBusinessType != 2"
        align="center"
        :show-overflow-tooltip="true"
        label="供应商"
        prop="supplierName"
      ></el-table-column>
      <el-table-column
        v-if="options.invoiceBusinessType != 2"
        :show-overflow-tooltip="true"
        align="center"
        prop="taskDt"
        label="供应商收款时间"
      >
        <template slot-scope="{ row }">{{ row.payDt | transAllTime }}</template>
      </el-table-column>

      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="taskDt"
        label="打款金额"
        key="taskDt"
      >
        <template slot-scope="{ row }">
          <el-button type="text" @click="showProjectPriceTable(row)">
            {{ row.orderAmount | moneyFixed }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row :gutter="24" type="flex" align="middle" justify="space-between">
      <el-row type="flex" align="middle">
        <div class="totalMoney" style="margin-left: 15px">
          <label>价税合计：</label>
          <span>{{ tableResp.invoiceAmount | moneyFixed }}</span>
        </div>
        <!--        <detail-of-project class="ml16" :data="tableResp"/>-->
      </el-row>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding: 15px"
      ></el-pagination>
    </el-row>
  </div>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import { invoice } from '@/api/ajax';
import { orderTypeList } from '@/config/staticData';
import projectPriceTable from '@/components/invoice/projectPriceTable';
// import createExtend from '@C/createExtend';
// import InvoiceTablePaymentDialog from './invoiceTable/invoice-table-payment-dialog';
import OrderServiceFee from '@/page/settlementCenter/orderMgmt/child/orderServiceFee/index.vue';
import BusServiceOrder from '@/page/settlementCenter/orderMgmt/child/busServiceOrder/index.vue';

const ORDER_TYPE = {
  1: '支付订单',
  2: '综合服务费',
  3: '委托代开(线上)',
  4: '园区个体',
  5: '商务服务费订单',
  6: '平台服务费订单'
};
export default {
  mixins: [pageInation, makeSure],
  components: {},
  props: {
    options: {}
  },
  filters: {
    // 与统一的发票订单类型不一致，问题很大
    orderType(v) {
      return ORDER_TYPE[v];
    }
  },
  data() {
    return {
      childNotSetPageNumStoreFlag: true,
      orderPriceDialog: true,
      orderTypeList,
      searchQuery: {
        id: this.options.id,
        invoiceBusinessType: this.options.invoiceBusinessType,
        invoiceApplyId: this.options.invoiceApplyId
      },
      getList: invoice.queryInvoiceOrder,
      loading: true
    };
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    },
    toFour(row) {
      this.$xrkDialog.remove();
      if (row.orderType == 1) {
        this.$router.push({
          path: '/orderMgmt/list',
          query: {
            orderNo: row.orderNo,
            part: 1,
            payType: row.payType
          }
        });
      } else {
        this.$router.push({
          path: '/orderMgmt/list',
          query: {
            orderNo: row.orderNo,
            part: 1,
            payType: row.payType
          }
        });
      }
    },
    showProjectPriceTable(row) {
      const {
        csoCustomOrderId,
        csoCustomOrderSupplierId,
        orderType,
        userEnterpriseType,
        invoiceApplyId
      } = row;
      const h = this.$createElement;
      if ([5, 6].includes(+orderType)) {
        this.$xrkDialog({
          title: '订单总金额',
          width: '80%',
          showConfirm: false,
          cancelText: '关闭',
          cancelType: 'primary',
          $slots: {
            default: h('div', [
              h(orderType == 6 ? OrderServiceFee : BusServiceOrder, {
                props: {
                  orderId: csoCustomOrderId || csoCustomOrderSupplierId,
                  userEnterpriseType
                }
              })
            ])
          }
        });
        // createExtend(InvoiceTablePaymentDialog);
      } else {
        this.$xrkDialog({
          title: '打款金额',
          width: '80%',
          showConfirm: false,
          cancelText: '确认',
          cancelType: 'primary',
          $slots: {
            default: h('div', [
              h(projectPriceTable, {
                props: {
                  query: {
                    ...row,
                    csoCustomOrderId,
                    //orderType==1:支付订单
                    csoCustomOrderSupplierId:
                      orderType === '1' ? csoCustomOrderSupplierId : '',
                    stateType: row.orderType,
                    invoiceApplyId
                  }
                }
              })
            ])
          }
        });
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.flexInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  img {
    max-width: 150px;
    margin-right: 10px;
  }
}
.colorBlock {
  font-size: 20px;
  line-height: 24px;
  display: flex;
  color: #2e2e2f;
  margin-bottom: 20px;
}
.colorBlock::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}
#openBill {
  .search-left {
    align-items: space-around;
    > div {
      display: flex;
      align-items: center;
      width: 400px;
      span {
        width: 100px;
        text-align: right;
      }
    }
    .search-input {
      margin-right: 0;
      input {
        padding: 0;
      }
    }
  }
  .totalMoney {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 15px;
    label {
      font-size: 14px;
      color: #666;
    }
    span {
      font-size: 20px;
      color: #333;
    }
    span:first-of-type {
      margin-right: 112px;
    }
  }
}
</style>
